const getData = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
) => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  if (process.env.ENVIRONMENT === "localhost" && !isToUseAuthZero) {
    headers = { ...headers, Authorization: `bearer ${process.env.TOKEN}` };
  }
  const res = await fetch(url, {
    method: "GET",
    headers,
  });

  const json = await res.json();
  if (res.status === 400) {
    throw new Error(json);
  }
  return json;
};

export default getData;
